import * as React from "react";
const SvgFiRrKipSign = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M22 13c0 .55-.45 1-1 1H8.94l10.67 8.21c.44.34.52.96.18 1.4-.2.26-.49.39-.79.39-.21 0-.43-.07-.61-.21L7 15.03V23c0 .55-.45 1-1 1s-1-.45-1-1v-9H3c-.55 0-1-.45-1-1s.45-1 1-1h2V1c0-.55.45-1 1-1s1 .45 1 1v9.72L18.32.27a.99.99 0 0 1 1.41.06c.38.41.35 1.04-.06 1.41L8.56 12H21c.55 0 1 .45 1 1"
    />
  </svg>
);
export default SvgFiRrKipSign;
